import { showUserAlert } from "./userErrorMessage";
export function clampDateString(value) {
  if (!value) return value;

  const match = String(value).match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!match) return value;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return value;

  const safeMonth = Math.min(Math.max(month, 1), 12);
  const lastDay = new Date(year, safeMonth, 0).getDate();
  const safeDay = Math.min(Math.max(day, 1), lastDay);

  return [
    String(year).padStart(4, "0"),
    String(safeMonth).padStart(2, "0"),
    String(safeDay).padStart(2, "0"),
  ].join("-");
}

export function normalizeDateRange(dateRange = {}) {
  return {
    ...dateRange,
    from: clampDateString(dateRange.from || ""),
    to: clampDateString(dateRange.to || ""),
  };
}

export function normalizeDateRangeState(state = {}) {
  if (!state?.dateRange) return state;
  return {
    ...state,
    dateRange: normalizeDateRange(state.dateRange),
  };
}

export function hasInvalidNativeDateInput(input) {
  if (!input) return false;
  return input.validity?.badInput || input.validity?.valid === false;
}

export function validateNativeDateInputs(inputs = []) {
  const invalidInput = inputs.find((input) => hasInvalidNativeDateInput(input));
  if (!invalidInput) return true;

  showUserAlert("존재하지 않는 날짜입니다. 해당 월의 마지막 날짜로 다시 선택해주세요.");
  invalidInput.focus?.();
  return false;
}
